import React from 'react';
import styled from 'styled-components';

import { useCardContext } from './card-context';
import { CardStrainType } from './card-strain-type';
import { CardPotency } from './card-potency';

type CardStrainDetailsProps = {
  /** Gap between items (px). Defaults to 6 (grid). List card uses 8. */
  gap?: number;
  /** Top margin (px). Defaults to 16 (grid). List card uses 12. */
  marginTop?: number;
};

/** Convenience wrapper rendering CardStrainType + CardPotency in a flex row. Renders nothing when both are absent. */
export function CardStrainDetails({ gap = 6, marginTop = 16 }: CardStrainDetailsProps = {}): JSX.Element | null {
  const { strainType, potency } = useCardContext();

  if (!strainType && potency.length === 0) {
    return null;
  }

  return (
    <Details $gap={gap} $marginTop={marginTop}>
      <CardStrainType />
      <CardPotency />
    </Details>
  );
}

const Details = styled.div<{ $gap: number; $marginTop: number }>`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: ${({ $gap }) => $gap}px;
  justify-content: var(--justify-content, flex-start);
  margin-top: ${({ $marginTop }) => $marginTop}px;
`;
